<template>
<DxChart :data-source="chartData" default-pane="bottomPane" title="Sales by month (5-year running average)" height="100%">
	<DxCommonSeriesSettings argument-field="month" />
	<DxSeries pane="topPane" color="#b0daff" type="rangeArea" range-value1-field="minT" range-value2-field="maxT" name="Warehouse error range" />
	<DxSeries pane="topPane" value-field="avgT" name="Reported subscribed">
		<DxLabel :visible="true" />
	</DxSeries>
	<DxSeries type="bar" value-field="prec" name="Warehouse/UOM units">
		<DxLabel :visible="true" />
	</DxSeries>
	<DxPane name="topPane"/>
	<DxPane name="bottomPane"/>
	<DxValueAxis pane="bottomPane">
		<DxGrid :visible="true"/>
		<DxTitle text="Units shipped (K)"/>
	</DxValueAxis>
	<DxValueAxis pane="topPane">
		<DxGrid :visible="true"/>
		<DxTitle text="Subscription Sales (K)"/>
	</DxValueAxis>
	<DxLegend vertical-alignment="bottom" horizontal-alignment="center" />
	<DxExport :enabled="true"/>
</DxChart>
</template>

<script setup>
import DxChart, { DxCommonSeriesSettings, DxSeries, DxPane, DxValueAxis, DxExport, DxLegend, DxLabel, DxTitle, DxGrid } from 'devextreme-vue/chart';
import { defineProps } from 'vue';
import ArrayStore from 'devextreme/data/array_store';

import { DxBox, DxItem } from 'devextreme-vue/box';	// eslint-disable-line no-unused-vars
import DxButton from 'devextreme-vue/button';	// eslint-disable-line no-unused-vars

const props = defineProps({
	preview: Boolean,
});

console.warn("CHART INITIALIZED", props);

const chartDataArray = [
	{ month: 'January', avgT: 9.8, minT: 4.1, maxT: 15.5, prec: 109, }, { month: 'February', avgT: 11.8, minT: 5.8, maxT: 17.8, prec: 104, }, { month: 'March', avgT: 13.4, minT: 7.2, maxT: 19.6, prec: 92, }, { month: 'April', avgT: 15.4, minT: 8.1, maxT: 22.8, prec: 30, }, { month: 'May', avgT: 18, minT: 10.3, maxT: 25.7, prec: 10, }, { month: 'June', avgT: 20.6, minT: 12.2, maxT: 29, prec: 2, }, { month: 'July', avgT: 22.2, minT: 13.2, maxT: 31.3, prec: 2, }, { month: 'August', avgT: 22.2, minT: 13.2, maxT: 31.1, prec: 1, }, { month: 'September', avgT: 21.2, minT: 12.4, maxT: 29.9, prec: 8, }, { month: 'October', avgT: 17.9, minT: 9.7, maxT: 26.1, prec: 24, }, { month: 'November', avgT: 12.9, minT: 6.2, maxT: 19.6, prec: 64, }, { month: 'December', avgT: 9.6, minT: 3.4, maxT: 15.7, prec: 76, }
];
const chartData = new ArrayStore({
	data: chartDataArray
});


</script>
